



import React from "react";
import "./Common_Btn.css";

const Common_Btn = ({
  text = "",
  onClick,
  type = "button",
  className = "",
  disabled = false,
}) => {
  return (
    <button
      type={type}
      className={`Common_Btn ${className}`}
      onClick={onClick}
      disabled={disabled}
    >
      {text}
    </button>
  );
};

export default Common_Btn;
